import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { mailroomKeys } from './keys';
import { MailResponse } from './types';

const getMails = async (options: MailQueryOptions) => {
  const queryParams = new URLSearchParams();

  if (options?.includeFiles) {
    queryParams.append('extends', 'FILES');
  }
  if (options?.mailroomIds && options.mailroomIds.length > 0) {
    queryParams.append('mailroomIds', options.mailroomIds.join(','));
  }

  const queryString = queryParams.toString();
  const url = `mailroom/mails${queryString ? `?${queryString}` : ''}`;

  const response = await fetcher(url, { method: 'GET' });

  if (!response.ok) throw new Error('Failed to fetch mails');

  return (await response.json()) as MailResponse;
};

type MailQueryOptions = {
  includeFiles?: boolean;
  mailroomIds: string[];
};

const useMails = (options: MailQueryOptions) => {
  return useQuery({
    queryKey: [mailroomKeys.FETCH_MAILS, options?.mailroomIds],
    queryFn: () => getMails(options),
    enabled: options.mailroomIds?.length > 0,
  });
};

export { useMails };
